/* Blak Sand — leather colour dots (19 Oct 2026). Build packet §2.
   1. Shelf cards: a hover (desktop) or a tap (phone) on a dot turns the card picture to that
      colour's "01 pair" frame without leaving the page; a second tap, or a click on desktop,
      opens the product on that colourway.
   2. Swatch zoom: a long press on a phone, or a 400 ms hover on desktop, over a product-page
      dot that has a swatch photo shows it as a small square with the leather's name. */
(function () {
  'use strict';
  if (window.__bsDots) return;
  window.__bsDots = true;
  var hoverable = !!(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches);
  function up(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  // ---- 1. cards ----
  function cardImg(card) { return card.querySelector('.bs-card__fr img'); }
  function swap(dot) {
    var card = up(dot, '.bs-card'), img = card && cardImg(card);
    if (!img || !dot.getAttribute('data-src')) return;
    if (img.getAttribute('data-o') == null) {
      img.setAttribute('data-o', img.getAttribute('src') || '');
      img.setAttribute('data-os', img.getAttribute('srcset') || '');
    }
    img.setAttribute('srcset', dot.getAttribute('data-srcset') || '');
    img.setAttribute('src', dot.getAttribute('data-src'));
    Array.prototype.forEach.call(card.querySelectorAll('.bs-card__sw i'), function (x) { x.classList.toggle('is-on', x === dot); });
  }
  function restore(card) {
    var img = cardImg(card);
    if (!img || img.getAttribute('data-o') == null) return;
    img.setAttribute('srcset', img.getAttribute('data-os'));
    img.setAttribute('src', img.getAttribute('data-o'));
    Array.prototype.forEach.call(card.querySelectorAll('.bs-card__sw i.is-on'), function (x) { x.classList.remove('is-on'); });
  }
  if (hoverable) {
    document.addEventListener('mouseover', function (e) { var d = up(e.target, '.bs-card__sw i[data-src]'); if (d) swap(d); });
    document.addEventListener('mouseout', function (e) {
      var c = up(e.target, '.bs-card');
      if (c && !c.contains(e.relatedTarget)) restore(c);
    });
  }
  document.addEventListener('click', function (e) {
    var d = up(e.target, '.bs-card__sw i[data-href]');
    if (!d) return;
    e.preventDefault();
    if (!hoverable && !d.classList.contains('is-on')) { swap(d); return; }
    location.href = d.getAttribute('data-href');
  }, true);

  // ---- 2. swatch zoom ----
  var pop = null, timer = null, longShown = false;
  function showPop(b) {
    if (!b || !b.getAttribute('data-sw')) return;
    if (!pop) {
      pop = document.createElement('div');
      pop.className = 'bs-swpop';
      pop.setAttribute('aria-hidden', 'true');
      pop.appendChild(document.createElement('img'));
      pop.appendChild(document.createElement('span'));
      document.body.appendChild(pop);
    }
    pop.firstChild.src = b.getAttribute('data-sw');
    pop.lastChild.textContent = b.getAttribute('data-leather') || '';
    var r = b.getBoundingClientRect();
    var left = Math.max(8, Math.min(document.documentElement.clientWidth - 170, r.left + r.width / 2 - 80));
    var top = r.top > 210 ? r.top - 200 : r.bottom + 10;
    pop.style.left = (left + window.scrollX) + 'px';
    pop.style.top = (top + window.scrollY) + 'px';
    pop.classList.add('is-on');
  }
  function hidePop() { clearTimeout(timer); if (pop) pop.classList.remove('is-on'); }
  if (hoverable) {
    document.addEventListener('mouseover', function (e) {
      var b = up(e.target, '.bs-pp__swb[data-sw]');
      if (!b) return;
      clearTimeout(timer);
      timer = setTimeout(function () { showPop(b); }, 400);
    });
    document.addEventListener('mouseout', function (e) {
      var b = up(e.target, '.bs-pp__swb[data-sw]');
      if (b && !b.contains(e.relatedTarget)) hidePop();
    });
  } else {
    document.addEventListener('touchstart', function (e) {
      var b = up(e.target, '.bs-pp__swb[data-sw]');
      if (!b) return;
      longShown = false;
      clearTimeout(timer);
      timer = setTimeout(function () { showPop(b); longShown = true; }, 500);
    }, { passive: true });
    var end = function () {
      clearTimeout(timer);
      if (longShown) setTimeout(function () { if (pop) pop.classList.remove('is-on'); }, 1200);
    };
    document.addEventListener('touchend', end, { passive: true });
    document.addEventListener('touchmove', function () { clearTimeout(timer); }, { passive: true });
    // a long press is a look, not a choice
    document.addEventListener('click', function (e) {
      if (!longShown || !up(e.target, '.bs-pp__swb[data-sw]')) return;
      longShown = false;
      e.preventDefault(); e.stopImmediatePropagation();
    }, true);
    document.addEventListener('contextmenu', function (e) { if (up(e.target, '.bs-pp__swb')) e.preventDefault(); });
  }
  window.addEventListener('scroll', function () { if (pop && pop.classList.contains('is-on')) hidePop(); }, { passive: true });
})();
